import { FormItem } from '../../../../../commons/Form/Form.types';
import { ProfileAccountFormCOMSchema } from './ProfileAccountFormCOM.types';

export const profileAccountCOMData: FormItem<ProfileAccountFormCOMSchema>[][] = [
  [
    {
      name: 'firstName',
      placeholder: 'Votre prénom...',
      label: 'Prénom',
      type: 'text',
      required: true,
    },
    {
      name: 'lastName',
      placeholder: 'Votre nom...',
      label: 'Nom',
      type: 'text',
      required: true,
    },
  ],
  [
    {
      name: 'email',
      placeholder: 'Votre adresse email...',
      label: 'Adresse email',
      type: 'text',
      required: true,
    },
    {
      name: 'phone',
      placeholder: 'Votre numéro de téléphone...',
      label: 'Téléphone',
      type: 'tel',
      required: true,
    },
  ],
];
